import {filterObjectArrayByAllFields} from "../../Utilities/Types/arrayUtilities";
import {getTodayDateAsString, isDateBetween} from "../../Utilities/Types/dateUtilities";
import {getTextByValue} from "../../Utilities/Types/listUtilities";
import {
    COPY_STATUS_LIST,
    FORMAT_LIST,
    GRADE_LEVEL_LIST,
    QUEUE_STATUS_LIST,
    SYSTEM_TYPES_LIST,
    TERMINAL_ORDER_STATUS,
    TERMINAL_ORDER_STATUS_LIST
} from "./libraryConstants";

export function filterCatalog(resources: Record<string, unknown>[], keywords: string) {
    return filterObjectArrayByAllFields(resources, keywords);
}

export function filterCatalogWhatsNew(catalog: Record<string, unknown>[] = []) {
    const today = getTodayDateAsString();
    return catalog.filter((c: Record<string, unknown>) => isDateBetween(today, c.whatsNewStartDate as string, c.whatsNewEndDate as string));
}

export const getCopyStatusTextByValue = (value: string | number = "") => getTextByValue(COPY_STATUS_LIST, value);

export const getFormatTextByValue = (value: string | number = "") => getTextByValue(FORMAT_LIST, value);

export const getGraveLevelTextByValue = (value: string | number = "") => getTextByValue(GRADE_LEVEL_LIST, value);

export const getQueueStatusTextByValue = (value: string | number = "") => getTextByValue(QUEUE_STATUS_LIST, value);

export const getSystemTypeTextByValue = (value: string | number = "") => getTextByValue(SYSTEM_TYPES_LIST, value);

export const getTerminalOrderStatusTextByValue = (value: string | number = "") => getTextByValue(TERMINAL_ORDER_STATUS_LIST, value);

export const areSystemTypesEqual = (type1: string | number = "", type2: string | number = "") => type1 === type2;

export function buildDuplicateWarningMessage(validationResult: Record<string, unknown>) {
    const duplicateItems = (validationResult.duplicateQueueItems as Record<string, unknown>[] | undefined) ?? [];

    if (duplicateItems.length === 0) {
        return "This student already has a matching textbook request in your organization/district. Do you want to continue?";
    }

    let message = "One or more selected items were already requested for this student by another patron in your organization/district:\n";

    duplicateItems.forEach((item) => {
        const itemTitle = String(item.catalogItemTitle ?? "");
        const itemFormat = String(item.catalogFormat ?? "");
        const patronName = String(item.existingPatronName ?? "");
        message += `\n ${itemTitle}${itemFormat ? `\n Format: ${itemFormat}` : ""}  \n Requested by: ${patronName} \n`;
    });

    message += "\n\nDo you want to continue anyway?";
    return message;
}

export function isTerminalOrderStatus(orderStatus: Number) {
    return Object.values(TERMINAL_ORDER_STATUS).includes(orderStatus as number);
}